import React, { useContext, useState } from 'react';
import CartContext, { CartItemProps } from 'stores/cart-context';
import IconCheck from 'assets/img/icon-check-1.svg';
import './courseHPC.css';
import { useTranslation } from 'react-i18next';
import GlobalStore, { Book } from 'stores/globalStore';

type PropTypes = {
  product: Book
};

const CourseIelts: React.FC<PropTypes> = ({
  product,
}) => {
  const [active, setActive] = useState<boolean>(false);
  const cartCtx = useContext(CartContext);
  const { t } = useTranslation();
  const { currentLanguage } = GlobalStore.useContainer();

  const handleActive = () => {
    setActive(!active);
  };

  const addToCart = (product: any) => {
    const item: CartItemProps = {
      membership: product.membership,
      name: product.name,
      price: product.discount_price,
      amount: 1
    };
    if (cartCtx.addItem) {
      cartCtx.addItem(item)
    }
  }

  const genSaleTags = (is_featured: boolean, percent: number, currentLanguage: string) => {
    if( is_featured ) {
      return currentLanguage === 'vi' ? 'Lựa chọn tốt nhất' : 'Best choice';
    } else {
        return currentLanguage === 'vi' ? `Giảm ${percent}%`: `Sale ${percent}%`;
    }
  };

  return (
    <div
      className={
        'hpc ' +
        (product.is_featured ? ' hpc--best' : '') +
        (active ? ' active' : '')
      }
    >
      <div className="hpc__content">
        <div className="content__header">
          <img src={product.thumbnail} alt={product.name} className="info__img" />
            <div className="content__info">
              <div className="info__tag">{genSaleTags(product.is_featured, product.discount_percent, currentLanguage)}</div>
              <h3 className="info__name">{product.name}</h3>
              <ul className="info__detail">
                
                {
                  product.membership === 'combo_ielts_band_6_7_9' ?
                  product.meta.include?.map(item =>
                    <li key={item} className="detail__item">
                      <img src={IconCheck} alt="icon" />
                      <span>{item}</span>
                    </li>
                  ) :
                  <>
                    {
                      product.meta.unit && <li className="detail__item">
                        <img src={IconCheck} alt="icon" />
                        <span>{product.meta.unit} units</span>
                      </li>
                    }
                    {
                      product.meta.lesson && <li className="detail__item">
                        <img src={IconCheck} alt="icon" />
                        <span>{product.meta.lesson} {currentLanguage === 'vi' ? 'bài học': 'lesson'}</span>
                      </li>
                    }
                  </>
                }
              </ul>
              <p className="content__des desktop">{currentLanguage === 'vi' ? 'Trình độ: Luyện thi IETLS' : 'Level: IELTS preparation'}</p>
          </div>
        </div>
        <div className="content__body">
          <ul className="info__detail">
            {
              product.membership === 'combo_ielts_band_6_7_9' ?
              product.meta.include?.map(item =>
                <li key={item} className="detail__item">
                  <img src={IconCheck} alt="icon" />
                  <span>{item}</span>
                </li>
              ) :
              <>
                {
                  product.meta.unit && <li className="detail__item">
                    <img src={IconCheck} alt="icon" />
                    <span>{product.meta.unit} units</span>
                  </li>
                }
                {
                  product.meta.lesson && <li className="detail__item">
                    <img src={IconCheck} alt="icon" />
                    <span>{product.meta.lesson} {currentLanguage === 'vi' ? 'bài học': 'lesson'}</span>
                  </li>
                }
              </>
            }
          </ul>
          <p className="content__des mobile">{currentLanguage === 'vi' ? 'Trình độ: Luyện thi IETLS' : 'Level: IELTS preparation'}</p>
        </div>
      </div>
      <div className="hpc__price">
        <div className="price-box">
          <del className="old__price">{product.base_price.toLocaleString('vn-VN')}đ</del>
          <p className="new__price">{product.discount_price.toLocaleString('vn-VN')}đ</p>
          <div className="info__tag">{genSaleTags(product.is_featured, product.discount_percent, currentLanguage)}</div>
        </div>
        <button
          className="payment"
          type="button"
          onClick={() => addToCart(product)}
        >
          <span className="payment-text">{t('courses.add_to_cart')}</span>
        </button>
      </div>
      <p className="toggle-detail" onClick={handleActive}>
        {active ? `${t('courses.back')}` : `${t('courses.view_detail')}`}
      </p>
    </div>
  );
};
export default CourseIelts;
